<link src="http://maxcdn.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css" rel="stylesheet">

<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"><link href="https://fonts.googleapis.com/css?family=Raleway|Titillium+Web" rel="stylesheet">
<link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css" rel="stylesheet"/>
<script src='https://kit.fontawesome.com/a076d05399.js' crossorigin='anonymous'></script>
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
<style>
  /* button start */
  .btn {
  background-color: DodgerBlue;
  border: none;
  color: white;
  padding: 12px 16px;
  font-size: 16px;
  cursor: pointer;
}

/* Darker background on mouse-over */
.btn:hover {
  background-color: #F58220;
}
/* buttonend */
  /* popup start  */


.popup
{
  z-index: 10;
/* width:450px; */
height:180px;
position:relative;
margin:223px auto;
display:block;
text-align:center;
-moz-background-clip: padding;
-o-background-clip: padding;
-webkit-background-clip: padding-box;
background-clip: padding-box; /* prevents bg color from leaking outside the border */
background-color: white; /* layer fill content */
-moz-box-shadow: 0 0 10px rgba(0,0,0,.18); /* drop shadow */
-webkit-box-shadow: 0 0 10px rgba(0,0,0,.18); /* drop shadow */
-o-box-shadow: 0 0 10px rgba(0,0,0,.18); /* drop shadow */
box-shadow: 0 0 10px rgba(0,0,0,.18); /* drop shadow */
-webkit-transform-origin:top center;
-moz-transform-origin:top center;
-o-transform-origin:top center;
transform-origin:top center;
-webkit-animation: iconosani 1.2s forwards;
animation: iconosani 1.2s forwards;
-moz-animation: iconosani 1.2s forwards;
-o-animation: iconosani 1.2s forwards;
}

@-webkit-keyframes iconosani {
    0% {
        -webkit-transform: perspective(800px) rotateX(-90deg);
        -moz-transform: perspective(800px) rotateX(-90deg);
        -o-transform: perspective(800px) rotateX(-90deg);
        opacity: 1;
    } 
    40% {
        -webkit-transform: perspective(800px) rotateX(30deg);
        -moz-transform: perspective(800px) rotateX(30deg);
        -o-transform: perspective(800px) rotateX(30deg);
        opacity: 1;
    }
    70% {
        -webkit-transform: perspective(800px) rotateX(-10deg);
        -moz-transform: perspective(800px) rotateX(-10deg);
        -o-transform: perspective(800px) rotateX(-10deg);
    }
    100% {
        -webkit-transform: perspective(800px) rotateX(0deg);
        -moz-transform: perspective(800px) rotateX(0deg);
        -o-transform: perspective(800px) rotateX(0deg);
        opacity: 1;
    }
}


.popScroll h1
{
  height: 60px;
  position: relative;
  color: #fff;
  font: 25px/60px sans-serif;
  text-align: center;
  text-transform: lowercase;
  background: #3D79D0;
}

.subscribe-widget .email-form {
font-size: 13px;
color: #999999;
padding-left: 6px;
width: 270px;
border: 1px solid #e0e0e0;
padding: 5px 0 5px 5px;
line-height: 25px;
}

.subscribe-widget .button {
background: #3D79D0;
padding: 6px 15px;
color: #fff;
border: none;
line-height: 25px;
margin-left:0;
cursor:pointer;
}

/* input[type="submit"] {
-webkit-appearance: button;
-moz-appearance: button;
-o-appearance: button;
cursor: pointer;
} */

.popScroll p { padding: 1px 5px; 	font-family: 'Open Sans'; font-size: 17px; margin-bottom: 10px;  }


#option { position: relative; }

.boxi {
	display: inline-block;
	width: 169px;
	line-height: 42px;
	color: #fff;
	text-align: center;
	text-decoration: none;
	-webkit-transition: all 0.1s linear;
	-moz-transition: all 0.1s linear;
	-o-transition: all 0.1s linear;
	}

#home { 
	background: #3D79D0;
	}

#close { 
	background: #D21111;
	}

.popScroll em {
	width: 42px;
	display: inline-block;
	position: relative;
	margin: 0 -20px;
	line-height: 42px;
	background: #fff;
	color: #777;
	text-align: center;
	border-radius: 50px;
	}

#home:hover { background: #1852C7;  }
#close:hover { background: #B30E0E; }


body.overlay:after{
  content:'';
  width:100%;
  height:100%;
  top:0px; left:0px;
  z-index:0;
  opacity:.8;
position:fixed; top:0; left:0; bottom:0; right:0;
  background:#000;
}

body.overlay{ /* Prevents scrolling */
  overflow:hidden;
  max-height:100%;
  max-width:100%;
}


.ribbon {
  position: absolute;
  z-index: 100;
  width: 100px;
  height: 100px;
  overflow: hidden;
}

.ribbon.top-left {
  top: -2.6px;
  left: -5px;
}

.ribbon.top-left.ribbon-primary > small {
  *zoom: 1;
  filter: progid:DXImageTransform.Microsoft.gradient(gradientType=0, startColorstr='#FF428BCA', endColorstr='#FF2A6496');
  background-image: -moz-linear-gradient(top, #428bca 0%, #2a6496 100%);
  background-image: -webkit-linear-gradient(top, #428bca 0%, #2a6496 100%);
  background-image: linear-gradient(to bottom, #3aa566 0%, #379347 100%);
  position: absolute;
  display: block;
  width: 100%;
  padding: 8px 10px;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 65%;
  color: white;
  background-color: #428bca;
  -moz-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  -moz-box-shadow: 0 3px 6px -3px rgba(0, 0, 0, 0.5);
  -webkit-box-shadow: 0 3px 6px -3px rgba(0, 0, 0, 0.5);
  box-shadow: 0 3px 6px -3px rgba(0, 0, 0, 0.5);
  top: 8px;
  left: -27px;
}
.ribbon.top-left.ribbon-primary > small:before, .ribbon.top-left.ribbon-primary > small:after {
  position: absolute;
  content: " ";
}
.ribbon.top-left.ribbon-primary > small:before {
  left: 0;
}
.ribbon.top-left.ribbon-primary > small:after {
  right: 0;
}
.ribbon.top-left.ribbon-primary > small:before, .ribbon.top-left.ribbon-primary > small:after {
  bottom: -3px;
  border-top: 3px solid #0e2132;
  border-left: 3px solid transparent;
  border-right: 3px solid transparent;
}

/* popup stop */

  /* @media screen and (-webkit-min-device-pixel-ratio:0) {
    input[type='range'] {
      overflow: hidden;
      width: 80px;
      -webkit-appearance: none;
      background-color: #9a905d;
    }
    
    input[type='range']::-webkit-slider-runnable-track {
      height: 10px;
      -webkit-appearance: none;
      color: #13bba4;
      margin-top: -1px;
    }
    
    input[type='range']::-webkit-slider-thumb {
      width: 10px;
      -webkit-appearance: none;
      height: 10px;
      cursor: ew-resize;
      background: #434343;
      box-shadow: -200px 0 0 200px black;
    }

} */
/** FF*/
input[type="range"]::-moz-range-progress {
  background-color: #43e5f7; 
}
input[type="range"]::-moz-range-track {  
  background-color: #9a905d;
}
/* IE*/
input[type="range"]::-ms-fill-lower {
  background-color: #43e5f7; 
}
input[type="range"]::-ms-fill-upper {  
  background-color: #9a905d;
}
 @import url('https://fonts.googleapis.com/css?family=Roboto:400,500,700');
*
{
    -webkit-box-sizing: border-box;
            box-sizing: border-box;
    margin: 0;
    padding: 0;
}



h1 {
  text-align: center;
  font-family: Tahoma, Arial, sans-serif;
  color: #06D85F;
  margin: 80px 0;
}



a
{
    text-decoration: none;
}
.product-card {
    width: 380px;
    position: relative;
    box-shadow: 0 2px 7px #dfdfdf;
    margin: 50px auto;
    background: #fafafa;
}

.badge {
    position: absolute;
    left: 0;
    top: 20px;
    text-transform: uppercase;
    font-size: 13px;
    font-weight: 700;
    background: red;
    color: #fff;
    padding: 3px 10px;
}

.product-tumb {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 300px;
    padding: 50px;
    background: #f0f0f0;
}

.product-tumb img {
    max-width: 100%;
    max-height: 100%;
}

.product-details {
    padding: 0px;
    color: white
}

.product-catagory {
    display: block;
    font-size: 16px;
    font-weight: 700;
    /* text-transform: uppercase; */
    color: white;
    margin-left: 150px;
    margin-bottom: 18px;
}

.product-details h4 a {
    font-weight: 500;
    display: block;
    margin-bottom: 18px;
    text-transform: uppercase;
    color: #363636;
    text-decoration: none;
    transition: 0.3s;
}

.product-details h4 a:hover {
    color: #fbb72c;
}

.product-details p {
    font-size: 15px;
    line-height: 22px;
    margin-bottom: 18px;
    color: #999;
}

.product-bottom-details {
    overflow: hidden;
    border-top: 1px solid #eee;
    padding-top: 20px;
}

.product-bottom-details div {
    float: left;
    width: 50%;
}

.product-price {
    font-size: 18px;
    color: #fbb72c;
    font-weight: 600;
}

.product-price small {
    font-size: 80%;
    font-weight: 400;
    text-decoration: line-through;
    display: inline-block;
    margin-right: 5px;
}

.product-links {
    text-align: right;
}

.product-links a {
    display: inline-block;
    margin-left: 5px;
    color: #e1e1e1;
    transition: 0.3s;
    font-size: 17px;
}

.product-links a:hover {
    color: #fbb72c;
}
.red{
  color:#F44336;
  font-size:22px;
  display:inline-block;
  margin: 0 5px;
}
@media screen and (max-width: 991px) {
  .wsk-cp-product{
    margin:40px auto;
  }
  .wsk-cp-product .wsk-cp-img{
  top:-40px;
}
.wsk-cp-product .wsk-cp-img img{
  box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);
}
  .wsk-cp-product .wsk-cp-text .category > span{
  border-color:#ddd;
  box-shadow: none;
  padding: 11px 28px;
}
.wsk-cp-product .wsk-cp-text .category{
  margin-top: 0px;
}
a.buy-btn{
  border-color: #FF9800;
  background: #FF9800;
  color: #fff;
}
}
   .modal-demo .ui-modal {
    width: 37.5rem;
    /* for resize limits use min-width, min-height, max-width, max-height in css */
  }
  .modal-demo .ui-modal-overlay, .modal-demo .ui-modal {
    z-index: 10;
  }
  /* colors */
  :root {
    --dt-color-primary: #2b7639;
  }
  /* for IE */
  .ui-modal-header {
    background-color: #2b7639;
  }




    :host {
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
      font-size: 14px;
      color: #333;
      box-sizing: border-box;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
  
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin: 8px 0;
    }
  
    p {
      margin: 0;
    }
  
    .spacer {
      flex: 1;
    }
  
    .toolbar {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 60px;
      display: flex;
      align-items: center;
      background-color: #1976d2;
      color: white;
      font-weight: 600;
    }
  
    .toolbar img {
      margin: 0 16px;
    }
  
    .toolbar #twitter-logo {
      height: 40px;
      margin: 0 16px;
    }
  
    .toolbar #twitter-logo:hover {
      opacity: 0.8;
    }
  
    .content {
      display: flex;
      margin: 73px auto -13px;
      padding: 0 0px;
      max-width: 960px;
      flex-direction: column;
      align-items: center;
      margin-top: 17%;
    }
  
    svg.material-icons {
      height: 24px;
      width: auto;
    }
  
    svg.material-icons:not(:last-child) {
      margin-right: 8px;
    }
  
    .card svg.material-icons path {
      fill: #888;
    }
  
    .card-container {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin-top: 16px;
    }
  
    .card {
      border-radius: 4px;
      border: 1px solid #eee;
      background-color: #fafafa;
      height: 40px;
      width: 200px;
      margin: 0 8px 16px;
      padding: 16px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      transition: all 0.2s ease-in-out;
      line-height: 24px;
    }
  
    .card-container .card:not(:last-child) {
      margin-right: 0;
    }
  
    .card.card-small {
      height: 16px;
      width: 168px;
    }
  
    .card-container .card:not(.highlight-card) {
      cursor: pointer;
    }
  
    .card-container .card:not(.highlight-card):hover {
      transform: translateY(-3px);
      box-shadow: 0 4px 17px rgba(0, 0, 0, 0.35);
    }
  
    .card-container .card:not(.highlight-card):hover .material-icons path {
      fill: rgb(105, 103, 103);
    }
  
    .card.highlight-card {
      background-color: #1976d2;
      color: white;
      font-weight: 600;
      border: none;
      width: auto;
      min-width: 30%;
      position: relative;
    }
  
    .card.card.highlight-card span {
      margin-left: 60px;
    }
  
    svg#rocket {
      width: 80px;
      position: absolute;
      left: -10px;
      top: -24px;
    }
  
    svg#rocket-smoke {
      height: calc(100vh - 95px);
      position: absolute;
      top: 10px;
      right: 180px;
      z-index: -10;
    }
  
    a,
    a:visited,
    a:hover {
      color: #1976d2;
      text-decoration: none;
    }
  
    a:hover {
      color: #125699;
    }
  
    .terminal {
      position: relative;
      width: 80%;
      max-width: 600px;
      border-radius: 6px;
      padding-top: 45px;
      margin-top: 8px;
      overflow: hidden;
      background-color: rgb(15, 15, 16);
    }
  
    .terminal::before {
      content: "\2022 \2022 \2022";
      position: absolute;
      top: 0;
      left: 0;
      height: 4px;
      background: rgb(58, 58, 58);
      color: #c2c3c4;
      width: 100%;
      font-size: 2rem;
      line-height: 0;
      padding: 14px 0;
      text-indent: 4px;
    }
  
    .terminal pre {
      font-family: SFMono-Regular,Consolas,Liberation Mono,Menlo,monospace;
      color: white;
      padding: 0 1rem 1rem;
      margin: 0;
    }
  
    .circle-link {
      height: 40px;
      width: 40px;
      border-radius: 40px;
      margin: 8px;
      background-color: white;
      border: 1px solid #eeeeee;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
      transition: 1s ease-out;
    }
  
    .circle-link:hover {
      transform: translateY(-0.25rem);
      box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
    }
  
    footer {
      margin-top: 8px;
      display: flex;
      align-items: center;
      line-height: 20px;
    }
  
    footer a {
      display: flex;
      align-items: center;
    }
  
    .github-star-badge {
      color: #24292e;
      display: flex;
      align-items: center;
      font-size: 12px;
      padding: 3px 10px;
      border: 1px solid rgba(27,31,35,.2);
      border-radius: 3px;
      background-image: linear-gradient(-180deg,#fafbfc,#eff3f6 90%);
      margin-left: 4px;
      font-weight: 600;
      font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol;
    }
  
    .github-star-badge:hover {
      background-image: linear-gradient(-180deg,#f0f3f6,#e6ebf1 90%);
      border-color: rgba(27,31,35,.35);
      background-position: -.5em;
    }
  
    .github-star-badge .material-icons {
      height: 16px;
      width: 16px;
      margin-right: 4px;
    }
  
    svg#clouds {
      position: fixed;
      bottom: -160px;
      left: -230px;
      z-index: -10;
      width: 1920px;
    }
  
  
    /* Responsive Styles */
    @media screen and (max-width: 767px) {
  
      .card-container > *:not(.circle-link) ,
      .terminal {
        width: 100%;
      }
  
      .card:not(.highlight-card) {
        height: 16px;
        margin: 8px 0;
      }
  
      .card.highlight-card span {
        margin-left: 72px;
      }
  
      svg#rocket-smoke {
        right: 120px;
        transform: rotate(-5deg);
      }
    }
  
    @media screen and (max-width: 575px) {
      svg#rocket-smoke {
        display: none;
        visibility: hidden;
      }
    }
  

    /* id change */
  	#lock{ display:none; }
     @media screen and (min-width: 320px) and (max-width: 767px) and (orientation:portrait ) {
     #lock{ display:block; }
    #con{ display:none; }
    }
     @media screen and (min-width: 320px) and (max-width: 767px) and (orientation: landscape) {
     #lock{ display:none; }
     #con{ display:block; }
    }
</style>
<style>
  .dropbtn {
  /* background-color: #04AA6D; */
  color: #FFF;
  font-family: 'Titillium Web', sans-serif;
  padding: 16px;
  font-size: 16px;
  border: none;
  font-weight: 400;
}

.dropdown {
  position: relative;
  /* display: inline-block; */
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #222222;
  min-width: 185px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
  /* margin: 11px; */
}

.dropdown-content a {
  color: white;
  padding: 12px 16px;
  font-family: 'Titillium Web', sans-serif;
  text-decoration: none;
  display: block;
}

.dropdown-content a:hover {background-color: #F58220;}

.dropdown:hover .dropdown-content {display: block;}

.dropdown:hover .dropbtn {color: #F58220}
  @import url(https://fonts.googleapis.com/css?family=Lato);

*, *:before, *:after{
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  font-family: 'Lato', sans-serif;
}

/*| Navigation |*/

nav{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #fff;
  box-shadow: 0 3px 10px -2px rgba(0,0,0,.1);
  border: 1px solid rgba(0,0,0,.1);
}
  nav ul{
    list-style: none;
    position: relative;
    float: right;
    margin-right: 100px;
    display: inline-table;
  }
    nav ul li{
      float: left;
      -webkit-transition: all .2s ease-in-out;
      -moz-transition: all .2s ease-in-out;
      transition: all .2s ease-in-out;
    }

    nav ul li:hover{background: rgba(0,0,0,.15);}
    nav ul li:hover > ul{display: block;}
    nav ul li{
      float: left;
      -webkit-transition: all .2s ease-in-out;
      -moz-transition: all .2s ease-in-out;
      transition: all .2s ease-in-out;
    }
      nav ul li a{
        display: block; 
        padding: 30px 20px;
        color: #222; 
        font-size: .9em;
        letter-spacing: 1px;
        text-decoration: none;
        text-transform: uppercase;
      }
      nav ul ul{
        display: none;
        background: #fff;
        position: absolute; 
        top: 100%;
        box-shadow: -3px 3px 10px -2px rgba(0,0,0,.1);
        border: 1px solid rgba(0,0,0,.1);
      }
        nav ul ul li{float: none; position: relative;}
          nav ul ul li a {
            padding: 15px 30px; 
            border-bottom: 1px solid rgba(0,0,0,.05);
          }
          nav ul ul ul {
            position: absolute; 
            left: 100%; 
            top:0;
          }	
  :host {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    font-size: 14px;
    color: #333;
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 8px 0;
  }

  p {
    margin: 0;
  }

  .spacer {
    flex: 0.9;
  }

  .toolbar {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 60px;
    display: flex;
    align-items: center;
    background-color: white;
    color: white;
    font-weight: 600;
  }

  .toolbar img {
    margin: 0 16px;
  }

  .toolbar #twitter-logo {
    height: 40px;
    margin: 0 16px;
  }

  .toolbar #twitter-logo:hover {
    opacity: 0.8;
  }

  .content {
    /* display: flex;
    margin: 82px auto 32px;
    padding: 0 16px;
    max-width: 960px;
    flex-direction: column;
    align-items: center; */

    display: flex;
    margin: 73px auto -13px;
    padding: 0 0px;
    max-width: 1580px;
    /* margin-left: 82px; */
    flex-direction: column;
    align-items: center;
  }

  svg.material-icons {
    height: 24px;
    width: auto;
  }

  svg.material-icons:not(:last-child) {
    margin-right: 8px;
  }

  .card svg.material-icons path {
    fill: #888;
  }

  .card-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 16px;
  }

  .card {
    border-radius: 4px;
    border: 1px solid #eee;
    background-color: #fafafa;
    height: 40px;
    width: 200px;
    margin: 0 8px 16px;
    padding: 16px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    transition: all 0.2s ease-in-out;
    line-height: 24px;
  }

  .card-container .card:not(:last-child) {
    margin-right: 0;
  }

  .card.card-small {
    height: 16px;
    width: 168px;
  }

  .card-container .card:not(.highlight-card) {
    cursor: pointer;
  }

  .card-container .card:not(.highlight-card):hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 17px rgba(0, 0, 0, 0.35);
  }

  .card-container .card:not(.highlight-card):hover .material-icons path {
    fill: rgb(105, 103, 103);
  }

  .card.highlight-card {
    background-color: #1976d2;
    color: white;
    font-weight: 600;
    border: none;
    width: auto;
    min-width: 30%;
    position: relative;
  }

  .card.card.highlight-card span {
    margin-left: 60px;
  }

  svg#rocket {
    width: 80px;
    position: absolute;
    left: -10px;
    top: -24px;
  }

  svg#rocket-smoke {
    height: calc(100vh - 95px);
    position: absolute;
    top: 10px;
    right: 180px;
    z-index: -10;
  }

  a,
  a:visited,
  a:hover {
    color: #1976d2;
    text-decoration: none;
  }

  a:hover {
    color: #125699;
  }

  .terminal {
    position: relative;
    width: 80%;
    max-width: 600px;
    border-radius: 6px;
    padding-top: 45px;
    margin-top: 8px;
    overflow: hidden;
    background-color: rgb(15, 15, 16);
  }

  .terminal::before {
    content: "\2022 \2022 \2022";
    position: absolute;
    top: 0;
    left: 0;
    height: 4px;
    background: rgb(58, 58, 58);
    color: #c2c3c4;
    width: 100%;
    font-size: 2rem;
    line-height: 0;
    padding: 14px 0;
    text-indent: 4px;
  }

  .terminal pre {
    font-family: SFMono-Regular,Consolas,Liberation Mono,Menlo,monospace;
    color: white;
    padding: 0 1rem 1rem;
    margin: 0;
  }

  .circle-link {
    height: 40px;
    width: 40px;
    border-radius: 40px;
    margin: 8px;
    background-color: white;
    border: 1px solid #eeeeee;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    transition: 1s ease-out;
  }

  .circle-link:hover {
    transform: translateY(-0.25rem);
    box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
  }

  footer {
    margin-top: 8px;
    display: flex;
    align-items: center;
    line-height: 20px;
  }

  footer a {
    display: flex;
    align-items: center;
  }

  .github-star-badge {
    color: #24292e;
    display: flex;
    align-items: center;
    font-size: 12px;
    padding: 3px 10px;
    border: 1px solid rgba(27,31,35,.2);
    border-radius: 3px;
    background-image: linear-gradient(-180deg,#fafbfc,#eff3f6 90%);
    margin-left: 4px;
    font-weight: 600;
    font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol;
  }

  .github-star-badge:hover {
    background-image: linear-gradient(-180deg,#f0f3f6,#e6ebf1 90%);
    border-color: rgba(27,31,35,.35);
    background-position: -.5em;
  }

  .github-star-badge .material-icons {
    height: 16px;
    width: 16px;
    margin-right: 4px;
  }

  svg#clouds {
    position: fixed;
    bottom: -160px;
    left: -230px;
    z-index: -10;
    width: 1920px;
  }


  /* Responsive Styles */
  @media screen and (max-width: 767px) {

    .card-container > *:not(.circle-link) ,
    .terminal {
      width: 100%;
    }

    .card:not(.highlight-card) {
      height: 16px;
      margin: 8px 0;
    }

    .card.highlight-card span {
      margin-left: 72px;
    }

    svg#rocket-smoke {
      right: 120px;
      transform: rotate(-5deg);
    }
  }

  @media screen and (max-width: 575px) {
    svg#rocket-smoke {
      display: none;
      visibility: hidden;
    }
  }

  .btn {
  background-color: #649aa1;
  border: none;
  color: white;
  font-family: 'Titillium Web', sans-serif;
  padding: 6px 13px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 27px;
}


  
</style>

<!-- Toolbar -->

<div id="con">
  <div class="toolbar" role="banner" style="background-image: url(http://dev.agtindia.co.in/propel-new/wp-content/themes/propel/images/head_bg.jpg);">
    <img
        height= 37px;
        width =115px;
        alt="Logo"
       src="/assets/img/logo1.png"
    />
    <!-- <div class="spacer"> -->

      <div >
        <div class="dropdown">
          <a class="dropbtn" aria-label="Angular on twitter" target="_blank" rel="noopener" >
            Products
           </a>
          <div class="dropdown-content">
            <a href="http://propel3d.stringsinfinity.com/">Track Mounted Jaw</a><hr style="border: 1px solid #5b594e;">
            <a href="http://propel3dcone.stringsinfinity.com/">Track Mounted Cone</a><hr style="border: 1px solid #5b594e;">
            <a href="http://propel3dvsi.stringsinfinity.com/">Track Mounted VSI</a><hr style="border: 1px solid #5b594e;">
            <a href="http://propel3dtms1561.stringsinfinity.com/">Track Mounted Screen 1561 - 3 Deck</a><hr style="border: 1px solid #5b594e;">
            <a href="http://propel3dviewtms1861.stringsinfinity.com/">Track Mounted Screen 1861 - 4 Deck</a>

          </div>
        </div>
      
      </div>
 
      <div>
        <div class="dropdown">
          <a class="dropbtn" aria-label="Angular on twitter" target="_blank" rel="noopener" >
            Downloads
           </a>
          <!-- <div class="dropdown-content">
            <a href="#">Track Mounted Jaw Crusher</a>
            <a href="#">Track Mounted Cone Crusher</a>
            <a href="#">Track Mounted Vertical Shaft Impactor</a>
            <a href="#">Track Mounted Screen - 4 Deck</a>
          </div> -->
        </div>
      </div>
      <div>
        <div class="dropdown">
          <a class="dropbtn" aria-label="Angular on twitter" target="_blank" rel="noopener" >
            Request for Quote 
           </a>
          <!-- <div class="dropdown-content">
            <a href="#">Track Mounted Jaw Crusher</a>
            <a href="#">Track Mounted Cone Crusher</a>
            <a href="#">Track Mounted Vertical Shaft Impactor</a>
            <a href="#">Track Mounted Screen - 4 Deck</a>
          </div> -->
        </div>
      </div>
    
  
      
  
      
      <!-- <div class="dropdown">
        <a class="dropbtn" aria-label="Angular on twitter" target="_blank" rel="noopener" style="margin-right: 7px;color: black;">
          PRODUCTS
         </a>
        <div class="dropdown-content">
          <a href="#">Track Mounted Jaw Crusher</a>
          <a href="#">Track Mounted Cone Crusher</a>
          <a href="#">Track Mounted Vertical Shaft Impactor</a>
          <a href="#">Track Mounted Screen - 4 Deck</a>
        </div>
      </div> -->
      
     
      <div class="spacer">
        <div class="dropdown">
          <a class="dropbtn" aria-label="Angular on twitter" target="_blank" rel="noopener" (click)="backtoweb()" >
            Contact Us
           </a>
          <!-- <div class="dropdown-content">
            <a href="#">Track Mounted Jaw Crusher</a>
            <a href="#">Track Mounted Cone Crusher</a>
            <a href="#">Track Mounted Vertical Shaft Impactor</a>
            <a href="#">Track Mounted Screen - 4 Deck</a>
          </div> -->
        </div>
      </div>
      <!-- <div >
        <div class="dropdown">
          <a class="dropbtn" aria-label="Angular on twitter" target="_blank" rel="noopener" (click)="backtoweb()" >
            Back to website
           </a>
      
        </div>
      </div> -->


   
      
      <!-- <a  style="font-size: 16px;color: gray;" aria-label="Angular on twitter" target="_blank" rel="noopener" href="https://www.propelind.com/" title="Twitter">
       CONTACT US 
      </a> -->
      <button class="btn" (click)="backtoweb()">Back to website
        <!-- <i style="font-size: 16px;margin-left: 7px;margin-top: 6px;color: white;" class="fa">&#x2192;</i> -->
      </button>

  </div>
  <div class="content" role="main">

    <div class="containernew" style="margin-top: -21px;">

      <a *ngIf = "firstimg == 1"><img  src="assets/images/imgwithenv/img/1861 (1).jpg">
      </a>
      <!-- <p  style="color: white;margin-left: 99px;"> {{value}}</p> -->
      
      <img class="hidden"   id="frame-72" src="assets/images/imgwithenv/img/1861 (2).jpg" (load)="dosomething($event)">
         <img class="hidden" id="frame-73" src="assets/images/imgwithenv/img/1861 (3).jpg">
          <img class="hidden" id="frame-74"src="assets/images/imgwithenv/img/1861 (4).jpg">
          <img class="hidden" id="frame-75" src="assets/images/imgwithenv/img/1861 (5).jpg">
          <img class="hidden" id="frame-76" src="assets/images/imgwithenv/img/1861 (6).jpg">
          <img class="hidden" id="frame-77" src="assets/images/imgwithenv/img/1861 (7).jpg">
          <img class="hidden" id="frame-78" src="assets/images/imgwithenv/img/1861 (8).jpg">
          <img class="hidden" id="frame-79" src="assets/images/imgwithenv/img/1861 (9).jpg">
          <img class="hidden" id="frame-80" src="assets/images/imgwithenv/img/1861 (10).jpg">
          <img class="hidden" id="frame-81" src="assets/images/imgwithenv/img/1861 (11).jpg">
          <img class="hidden" id="frame-82" src="assets/images/imgwithenv/img/1861 (12).jpg">
          <img class="hidden" id="frame-83" src="assets/images/imgwithenv/img/1861 (13).jpg">
          <img class="hidden" id="frame-84" src="assets/images/imgwithenv/img/1861 (14).jpg">
          <img class="hidden" id="frame-85" src="assets/images/imgwithenv/img/1861 (15).jpg">
          <img class="hidden" id="frame-86"   src="assets/images/imgwithenv/img/1861 (16).jpg">
          <img class="hidden" id="frame-87"   src="assets/images/imgwithenv/img/1861 (17).jpg">
          <img class="hidden" id="frame-88"   src="assets/images/imgwithenv/img/1861 (18).jpg">
          <img class="hidden" id="frame-89"   src="assets/images/imgwithenv/img/1861 (19).jpg">
          <img class="hidden" id="frame-90"   src="assets/images/imgwithenv/img/1861 (20).jpg">
          <img class="hidden" id="frame-91"   src="assets/images/imgwithenv/img/1861 (21).jpg">
          <img class="hidden" id="frame-92"   src="assets/images/imgwithenv/img/1861 (22).jpg">
          <img class="hidden" id="frame-93"   src="assets/images/imgwithenv/img/1861 (23).jpg">
          <img class="hidden" id="frame-94"   src="assets/images/imgwithenv/img/1861 (24).jpg">
          <img class="hidden" id="frame-95"   src="assets/images/imgwithenv/img/1861 (25).jpg">
          <img class="hidden" id="frame-96"   src="assets/images/imgwithenv/img/1861 (26).jpg">
          <img class="hidden" id="frame-97"   src="assets/images/imgwithenv/img/1861 (27).jpg">
          <img class="hidden" id="frame-98"   src="assets/images/imgwithenv/img/1861 (28).jpg">
          <img class="hidden" id="frame-99"   src="assets/images/imgwithenv/img/1861 (29).jpg">
          <img class="hidden" id="frame-100"   src="assets/images/imgwithenv/img/1861 (30).jpg">
          <img class="hidden" id="frame-101"   src="assets/images/imgwithenv/img/1861 (31).jpg">
          <img class="hidden" id="frame-102"   src="assets/images/imgwithenv/img/1861 (32).jpg">
          <img class="hidden" id="frame-103"   src="assets/images/imgwithenv/img/1861 (33).jpg">
          <img class="hidden" id="frame-104"   src="assets/images/imgwithenv/img/1861 (34).jpg">
          <img class="hidden" id="frame-105"   src="assets/images/imgwithenv/img/1861 (35).jpg">
          <img class="hidden" id="frame-106"   src="assets/images/imgwithenv/img/1861 (36).jpg">
          <img class="hidden" id="frame-107"   src="assets/images/imgwithenv/img/1861 (37).jpg">
          <img class="hidden" id="frame-108"   src="assets/images/imgwithenv/img/1861 (38).jpg">
          <img class="hidden" id="frame-109"   src="assets/images/imgwithenv/img/1861 (39).jpg">
          <img class="hidden" id="frame-110"   src="assets/images/imgwithenv/img/1861 (40).jpg">
          <img class="hidden" id="frame-111"   src="assets/images/imgwithenv/img/1861 (41).jpg">
          <img class="hidden" id="frame-112"   src="assets/images/imgwithenv/img/1861 (42).jpg">
          <img class="hidden" id="frame-113"   src="assets/images/imgwithenv/img/1861 (43).jpg">
          <img class="hidden" id="frame-114"   src="assets/images/imgwithenv/img/1861 (44).jpg">
          <img class="hidden" id="frame-115"   src="assets/images/imgwithenv/img/1861 (45).jpg">
          <img class="hidden" id="frame-116"   src="assets/images/imgwithenv/img/1861 (46).jpg">
          <img class="hidden" id="frame-117"   src="assets/images/imgwithenv/img/1861 (47).jpg">
          <img class="hidden" id="frame-118"   src="assets/images/imgwithenv/img/1861 (48).jpg">
          <img class="hidden" id="frame-119"   src="assets/images/imgwithenv/img/1861 (49).jpg">
          <img class="hidden" id="frame-120"   src="assets/images/imgwithenv/img/1861 (50).jpg">
          <img class="hidden" id="frame-121"   src="assets/images/imgwithenv/img/1861 (51).jpg">
          <img class="hidden" id="frame-122"   src="assets/images/imgwithenv/img/1861 (52).jpg">
          <img class="hidden" id="frame-123"   src="assets/images/imgwithenv/img/1861 (53).jpg">
          <img class="hidden" id="frame-124"   src="assets/images/imgwithenv/img/1861 (54).jpg">
          <img class="hidden" id="frame-125"   src="assets/images/imgwithenv/img/1861 (55).jpg">
          <img class="hidden" id="frame-126"   src="assets/images/imgwithenv/img/1861 (56).jpg">
          <img class="hidden" id="frame-127"   src="assets/images/imgwithenv/img/1861 (57).jpg">
          <img class="hidden" id="frame-128"   src="assets/images/imgwithenv/img/1861 (58).jpg">
          <img class="hidden" id="frame-129"   src="assets/images/imgwithenv/img/1861 (59).jpg">
          <img class="hidden" id="frame-130"   src="assets/images/imgwithenv/img/1861 (60).jpg">
          <img class="hidden" id="frame-131"   src="assets/images/imgwithenv/img/1861 (61).jpg">
          <img class="hidden" id="frame-132"   src="assets/images/imgwithenv/img/1861 (62).jpg">
          <img class="hidden" id="frame-133"   src="assets/images/imgwithenv/img/1861 (63).jpg">
          <img class="hidden" id="frame-134"   src="assets/images/imgwithenv/img/1861 (64).jpg">
          <img class="hidden" id="frame-135"   src="assets/images/imgwithenv/img/1861 (65).jpg">
          <img class="hidden" id="frame-136"   src="assets/images/imgwithenv/img/1861 (66).jpg">
          <img class="hidden" id="frame-137"   src="assets/images/imgwithenv/img/1861 (67).jpg">
          <img class="hidden" id="frame-138"   src="assets/images/imgwithenv/img/1861 (68).jpg">
          <img class="hidden" id="frame-139"   src="assets/images/imgwithenv/img/1861 (69).jpg">
          <img class="hidden" id="frame-140"   src="assets/images/imgwithenv/img/1861 (70).jpg">
          <img class="hidden" id="frame-141"   src="assets/images/imgwithenv/img/1861 (71).jpg">
          <img class="hidden" id="frame-142"   src="assets/images/imgwithenv/img/1861 (72).jpg">
          <img class="hidden" id="frame-143"   src="assets/images/imgwithenv/img/1861 (73).jpg">
          <img class="hidden" id="frame-144"   src="assets/images/imgwithenv/img/1861 (74).jpg">
          <img class="hidden" id="frame-145"   src="assets/images/imgwithenv/img/1861 (75).jpg">
          <img class="hidden" id="frame-146"   src="assets/images/imgwithenv/img/1861 (76).jpg">
          <img class="hidden" id="frame-147"   src="assets/images/imgwithenv/img/1861 (77).jpg">
          <img class="hidden" id="frame-148"   src="assets/images/imgwithenv/img/1861 (78).jpg">
          <img class="hidden" id="frame-149"   src="assets/images/imgwithenv/img/1861 (79).jpg">
          <img class="hidden" id="frame-150"   src="assets/images/imgwithenv/img/1861 (80).jpg">
          <img class="hidden" id="frame-151"   src="assets/images/imgwithenv/img/1861 (81).jpg">
          <img class="hidden" id="frame-152"   src="assets/images/imgwithenv/img/1861 (82).jpg">
          <img class="hidden" id="frame-153"   src="assets/images/imgwithenv/img/1861 (83).jpg">
          <img class="hidden" id="frame-154"   src="assets/images/imgwithenv/img/1861 (84).jpg">
          <img class="hidden" id="frame-155"   src="assets/images/imgwithenv/img/1861 (85).jpg">
          <img class="hidden" id="frame-156"   src="assets/images/imgwithenv/img/1861 (86).jpg">
          <img class="hidden" id="frame-156"   src="assets/images/imgwithenv/img/1861 (87).jpg">
          <img class="hidden" id="frame-157"   src="assets/images/imgwithenv/img/1861 (88).jpg">
          <img class="hidden" id="frame-158"   src="assets/images/imgwithenv/img/1861 (89).jpg">
          <img class="hidden" id="frame-159"   src="assets/images/imgwithenv/img/1861 (90).jpg">
          <img class="hidden" id="frame-160"   src="assets/images/imgwithenv/img/1861 (91).jpg">
          <img class="hidden" id="frame-161"   src="assets/images/imgwithenv/img/1861 (92).jpg">
          <img class="hidden" id="frame-162"   src="assets/images/imgwithenv/img/1861 (93).jpg">
          <img class="hidden" id="frame-163"   src="assets/images/imgwithenv/img/1861 (94).jpg">
          <img class="hidden" id="frame-164"   src="assets/images/imgwithenv/img/1861 (95).jpg">
          <img class="hidden" id="frame-165"   src="assets/images/imgwithenv/img/1861 (96).jpg">
          <img class="hidden" id="frame-166"   src="assets/images/imgwithenv/img/1861 (97).jpg">
          <img class="hidden" id="frame-167"   src="assets/images/imgwithenv/img/1861 (98).jpg">
          <img class="hidden" id="frame-168"   src="assets/images/imgwithenv/img/1861 (99).jpg">
          <img class="hidden" id="frame-169"   src="assets/images/imgwithenv/img/1861 (100).jpg">

          
             
      <div  id="mousevalue" (click)="modalRoot.show();imagemoveforpopup()"  class="hotspot mouse" text="Feed Hopper" >
        <i style="font-size: 16px;margin-left: 7px;margin-top: 6px;color: white;" class="fa">&#xf067;</i>
      </div>

      <div id="vasechange"  (click)="envroot.show();imagemoveforpopup()" class="hotspot vase" text="Ergonomic Design">
        <i style="font-size: 16px;margin-left: 7px;margin-top: 6px;color: white;" class="fa">&#xf067;</i>
      </div>
      <div id="dust"  (click)="modalRootdust.show();imagemoveforpopup()" class="hotspot dust" text="Dust Suppression System">
        <i style="font-size: 16px;margin-left: 7px;margin-top: 6px;color: white;" class="fa">&#xf067;</i>
      </div>
     
      
        <div  id="jaw" (click)="modalRootjaw.show();imagemoveforpopup()"  class="hotspot jaw" text="Vibrating Screen" >
          <i style="font-size: 16px;margin-left: 7px;margin-top: 6px;color: white;" class="fa">&#xf067;</i>
        </div>
      

      <div id="track" (click)="modalRoottrack.show();imagemoveforpopup()"  class="hotspot track" text="Wireless Tracking Remote" >
        <i style="font-size: 16px;margin-left: 7px;margin-top: 6px;color: white;" class="fa">&#xf067;</i>
      </div>

      <div id="lm" (click)="modalRootlm.show();imagemoveforpopup()"  class="hotspot lm" text="Light Mast" >
        <i style="font-size: 16px;margin-left: 7px;margin-top: 6px;color: white;" class="fa">&#xf067;</i>
    
      </div>

      <div id="dpi" (click)="modalRootdpi.show();imagemoveforpopupdualpow()"  class="hotspot dpi" text="Dual Power Input" >
        <i style="font-size: 16px;margin-left: 7px;margin-top: 6px;color: white;" class="fa">&#xf067;</i>
        
      </div>

      <div id="pow" (click)="modalRootpow.show();imagemoveforpopup()"  class="hotspot pow" text="Power Source with Acoustic Canopy" >
        <i style="font-size: 16px;margin-left: 7px;margin-top: 6px;color: white;" class="fa">&#xf067;</i>
        
      </div>

      <div id="metal" (click)="modalRootmetal.show();imagemoveforpopup()"  class="hotspot metal" text="Conveyors" >
        <i style="font-size: 16px;margin-left: 7px;margin-top: 6px;color: white;" class="fa">&#xf067;</i>
      </div>

      <div hidden>
        <div id="track" (click)="modalRoottrack.show();imagemoveforpopup()"  class="hotspot track" text="Wireless Tracking Remote" >
          <i style="font-size: 16px;margin-left: 7px;margin-top: 6px;color: white;" class="fa">&#xf067;</i>
        </div>
      </div>
     
      <div *ngIf = "slideron == 0" class="centered">
        <div class="input-group"> 

          <div class="text-center" style="margin-top: 7px;width: 500px;">
            <ngx-slider  style="background-color: #379347;" [(value)]="value" [options]="options"  class="form-range" id="customRange2"  (userChange)="sliderEvent()"></ngx-slider>

          </div>		
        </div>
        <div   class="text-center" style="color: #c8c4b0;margin-left: 177px;" >
          <p style="color: #c8c4b0">Click & hold to rotate</p>
        </div>
    </div>
        
    </div>
     

  </div>
 
  <ngx-modal-window #modalRoot class="modal-demo" style="display: block;visibility: visible;left: 29px;top: 162.5px;">

  
    <ng-container class="app-modal-header"><h4 style="color: white;font-size: 18px;">Feed Hopper</h4></ng-container>
    <ng-container class="app-modal-body">
      <img src="assets/img/TMS 1816 Feed Hopper.jpg" alt=""  style="width: 108.5%;margin-top: -19px;margin-left: -15px;height: 298px;"/>
      <div class="product-details">
        <mat-tab-group >
          <mat-tab label="Overview">
            <ul>
              <li><h4> &#9658;Even feed distribution.</h4></li>
              <li><h4> &#9658;Impact resistance.</h4></li>
            </ul>  
          </mat-tab>
          <mat-tab label="Specification">
            <ul> 
              <li><h4> &#9658; <b>Feed Height</b>- 2450 mm </h4></li>
              <li><h4> &#9658; <b>Hopper Capacity</b>- 2 cubic.meter </h4></li>
            </ul>  
          </mat-tab>
        </mat-tab-group>


        <!-- <span class="product-catagory">Women,bag</span> -->
      </div>

      <hr>

    </ng-container>
    <ng-container class="app-modal-footer">
      <span (click)="fromfeedho();modalRoot.hide();envroot.show()" class="product-catagory">Ergonomic Design <img style="height: 37px;margin-bottom: -15px;" src="assets/arr.svg"></span>
    </ng-container>
   
  </ngx-modal-window>

  <ngx-modal-window #envroot class="modal-demo" style="display: block;visibility: visible;left: 29px;top: 162.5px;">
    <ng-container class="app-modal-header"><h4 style="color: white;font-size: 18px;">Ergonomic Design</h4></ng-container>
    <ng-container class="app-modal-body">
      <img src="assets/img/er.jpg" alt=""  style="width: 108.5%;margin-top: -19px;margin-left: -15px;height: 298px;"/>
     
      <div class="product-details">
        <mat-tab-group mat-align-tabs="start">
          <mat-tab label="Overview">
            <ul>
              <li><h4> &#9658; Robust in strength.</h4></li>
              <li><h4> &#9658; Easy for operation & maintenance.</h4></li>
              <li><h4> &#9658; Safe for working.</h4></li>
            </ul>  
          </mat-tab>
          <!-- <mat-tab label="Specification">
            <ul>
              <li><h4> &#9658; <b>Belt Feeder</b>- 11kW Motorized Pulley</h4></li>
              <li><h4> &#9658; <b>Main Conveyor</b> - 11 kW Motorized pulley</h4></li>

            </ul>  
          </mat-tab> -->
        </mat-tab-group>
      </div>
      <hr>
    </ng-container>
    <ng-container class="app-modal-footer">
      <span (click)="fromenv();envroot.hide();modalRootlm.show()" class="product-catagory">Light Mast<img style="height: 37px;margin-bottom: -15px;" src="assets/arr.svg"> </span>
    </ng-container>
  </ngx-modal-window>

  <ngx-modal-window #modalRootlm class="modal-demo" style="display: block;visibility: visible;left: 29px;top: 162.5px;">
    <ng-container class="app-modal-header"><h4 style="color: white;font-size: 18px;">Light Mast<br>(Optional Feature)</h4></ng-container>
    <ng-container class="app-modal-body">
      <img src="assets/img/TMS 1861 lightmust.jpg" alt=""  style="width: 108.5%;margin-top: -19px;margin-left: -15px;height: 298px;"/>

      <div class="product-details">
        <mat-tab-group mat-align-tabs="start">
          <mat-tab label="Overview">
              <ul>
                <li><h4> &#9658; Increased visibility during dark / night operation.</h4></li>
                <li><h4> &#9658; Effective illumination with Inbuilt LED.</h4></li>
                <li><h4> &#9658; Foldable telescopic mounts helps for easy shipments.</h4></li>
              </ul>  
              </mat-tab>
        </mat-tab-group>
      </div>
      <hr>
    </ng-container>
    <ng-container class="app-modal-footer">
      <span (click)="fromenv();modalRootlm.hide();modalRootpow.show()" class="product-catagory">Power Source<img style="height: 37px;margin-bottom: -15px;" src="assets/arr.svg"> </span>
    </ng-container>
  </ngx-modal-window>

  

  <ngx-modal-window #modalRootpow class="modal-demo" style="display: block;visibility: visible;left: 29px;top: 162.5px;">
    <ng-container class="app-modal-header"><h4 style="color: white;font-size: 18px;">Power Source with Acoustic Canopy</h4></ng-container>
    <ng-container class="app-modal-body">
      <img src="assets/img/TMS 1861 Parts Enging power souce.jpg" alt=""  style="width: 108.5%;margin-top: -19px;margin-left: -15px;height: 298px;"/>
      <div class="product-details">
        <mat-tab-group mat-align-tabs="start">
          <mat-tab label="Overview">
            <ul>
              <li><h4> &#9658; Fuel Efficient Power Source with In-built Alternator.</h4></li>
              <li><h4> &#9658; Well-insulated engine, dust & water-resistant.</h4></li>
              <li><h4> &#9658; Lower operational noise ( suitable for urban areas).</h4></li>
            </ul>  
          </mat-tab>
          <mat-tab label="Specification">
            <ul><h3 style="color: #c36718;">Power Unit</h3>            
              <li><h4> &#9658;Volvo Eicher Commercial Vehicles <b>(VECV) EE694 TCI</b>  Engine with Leroy Somer alternator</h4></li>
              <li><h4> &#9658; <b>Diesel Tank Capacity</b> - 1000 liters</h4> </li>
    
          </ul>
          </mat-tab>
        </mat-tab-group>
      </div>


      <hr>
    </ng-container>
    <ng-container class="app-modal-footer">
      <span (click)="fromenv();modalRootpow.hide();modalRootjaw.show()" class="product-catagory">Vibrating Screen <img style="height: 37px;margin-bottom: -15px;" src="assets/arr.svg"> </span>
    </ng-container>
  </ngx-modal-window>

  <ngx-modal-window #modalRootjaw class="modal-demo" style="display: block;visibility: visible;left: 29px;top: 162.5px;">
    <ng-container class="app-modal-header"><h4 style="color: white;font-size: 18px;">Vibrating Screen</h4></ng-container>
    <ng-container class="app-modal-body">
      <img src="assets/img/TMS 1816 Vibrating screen.jpg" alt=""  style="width: 108.5%;margin-top: -19px;margin-left: -15px;height: 298px;"/>
      <div class="product-details">
        <mat-tab-group mat-align-tabs="start">
          <mat-tab label="Overview">
            <ul>
              <li><h4> &#9658;Oil Lubricated Independent Bearing Cartridge.</h4></li>
              <li><h4> &#9658;Wider Screening Area.</h4></li>
              <li><h4> &#9658;Quick Fixing of Wire Mesh.</h4></li>
              <li><h4> &#9658;Well protected feedbox and discharge chute.</h4></li>
            </ul>  
          </mat-tab>
          <mat-tab label="Specification">
            <ul>            
              <li><h4> &#9658; <b>Capacity</b>- Max. 600 TPH</h4></li>
              <li><h4> &#9658; <b>Top & Middle Deck Size</b> - 6000 mm x 1800 mm</h4> </li>
              <li><h4> &#9658; <b>Third Deck Size</b> - 5530 mm x 1800 mm</h4></li> 
              <li><h4> &#9658; <b>Bottom Deck Size</b> - 5400 mm x 1800 mm</h4></li> 
              <li><h4> &#9658; <b>Operating Angle</b> - 16° - 20°</h4></li> 
              <li><h4> &#9658; <b>Drive Power</b> - 18.5 kW</h4></li> 
          </ul>
          </mat-tab>
        </mat-tab-group>
        <!-- <span class="product-catagory">Women,bag</span> -->
      </div>
      <hr>
    </ng-container>
    <ng-container class="app-modal-footer">
      <span (click)="fromenv();modalRootjaw.hide();modalRoottrack.show()" class="product-catagory">Wireless Tracking Remote<img style="height: 37px;margin-bottom: -15px;" src="assets/arr.svg"> </span>
    </ng-container>
  </ngx-modal-window>

  <ngx-modal-window #modalRoottrack class="modal-demo" style="display: block;visibility: visible;left: 29px;top: 162.5px;">
    <ng-container class="app-modal-header"><h4 style="color: white;font-size: 18px;">Wireless Tracking Remote <br>(Optional Feature)</h4></ng-container>
    <ng-container class="app-modal-body">
      <img src="assets/img/TMS 1861 Wireless tracking remote.jpg" alt=""  style="width: 108.5%;margin-top: -19px;margin-left: -15px;height: 298px;"/>

      <div class="product-details">
        <mat-tab-group mat-align-tabs="start">
          <mat-tab label="Overview">
            <ul>
              <li><h4> &#9658; Finest wireless track control.</h4></li>
              <li><h4> &#9658; Easy & wide range of commands for marching.</h4></li>
              <li><h4> &#9658; Operator convenience & safety guaranteed.</h4></li>
            </ul>  
          </mat-tab>
        </mat-tab-group>
      </div>
      <hr>
    </ng-container>
    <ng-container class="app-modal-footer">
      <span (click)="fromtrack();modalRoottrack.hide();modalRootdpi.show()" class="product-catagory">Dual Power Input <img style="height: 37px;margin-bottom: -15px;" src="assets/arr.svg"> </span>
    </ng-container>
  </ngx-modal-window>

  <ngx-modal-window #modalRootdpi class="modal-demo" style="display: block;visibility: visible;left: 29px;top: 162.5px;">
    <ng-container class="app-modal-header"><h4 style="color: white;font-size: 18px;">Dual Power Input <br>(Optional Feature)</h4></ng-container>
    <ng-container class="app-modal-body">
      <img src="assets/img/TMS 1861 dual power unit.jpg" alt=""  style="width: 108.5%;margin-top: -19px;margin-left: -15px;height: 298px;"/>

      <div class="product-details">
        <mat-tab-group mat-align-tabs="start">
          <mat-tab label="Overview">
            <ul>
              <li><h4> &#9658; Driven by electricity / diesel.</h4></li>
              <li><h4> &#9658; Quick & easy switch between modes.</h4></li>
              <li><h4> &#9658; Effective power saving.</h4></li>
              <li><h4> &#9658; Hybrid plug & play power pack.</h4></li>
            </ul>  
          </mat-tab>
          <mat-tab label="Specification">
            <ul><h3 style="color: #c36718;">Input Power from External Source</h3>            
              <li><h4> &#9658; <b>Voltage</b> - 415 V</h4></li>
              <li><h4> &#9658; <b>Frequency</b> - 50 Hz, 3ɸ</h4> </li>
    
          </ul>
          </mat-tab>
        </mat-tab-group>
        <!-- <span class="product-catagory">Women,bag</span> -->
      </div>
      <hr>
    </ng-container>
    <ng-container class="app-modal-footer">
      <span (click)="fromenv();modalRootdpi.hide();modalRootdust.show()" class="product-catagory">Dust Suppression System<img style="height: 37px;margin-bottom: -15px;" src="assets/arr.svg"> </span>
    </ng-container>
  </ngx-modal-window>


  <ngx-modal-window #modalRootmetal class="modal-demo" style="display: block;visibility: visible;left: 29px;top: 162.5px;">
    <ng-container class="app-modal-header"><h4 style="color: white;font-size: 18px;">Conveyors</h4></ng-container>
    <ng-container class="app-modal-body">
      <img src="assets/img/TMS 1816Conveyors.jpg" alt=""  style="width: 108.5%;margin-top: -19px;margin-left: -15px;height: 298px;"/>

      <div class="product-details">
        <mat-tab-group mat-align-tabs="start">
          <mat-tab label="Overview">
            <ul>
              <li><h4> &#9658;5 products (or) 4 products with recirculation.</h4></li>
              <li><h4> &#9658;Compatible with any machines in secondary & tertiary stage.</h4></li>
              <li><h4> &#9658;Motorized Pulley (Less Power, Less End Load, Less Maintenance).</h4></li>
              <li><h4> &#9658;Endless Belt (High availability, High Reliability).</h4></li>
              <li><h4> &#9658;Main conveyor lift up facility to access top deck.</h4></li>
              <li><h4> &#9658;Fines conveyor drop down facility to access bottom deck.</h4></li>


  
            </ul>  
          </mat-tab>
          <mat-tab label="Specification">
            <ul>            
              <li><h4> &#9658; <b>Main Conveyor</b> -11 kW (Motorized Pulley)</h4> </li>
              <li><h4> &#9658; <b>Oversize Side Conveyor</b> - 5.5 kW (Motorized Pulley)</h4></li> 
              <li><h4> &#9658; <b>Mid Oversize Side Conveyor</b> - 5.5 kW (Motorized Pulley)</h4></li> 

              <li><h4> &#9658; <b>Midsize Side Conveyor</b> - 5.5 kW (Motorized Pulley)</h4></li> 
              <li><h4> &#9658; <b>Bottom Deck Side Conveyor</b> -  5.5 kW (Motorized Pulley)</h4></li> 
              <li><h4> &#9658; <b>Under Size Product Conveyor</b> -  5.5 kW (Motorized Pulley)</h4></li> 
              <li><h4> &#9658; <b>Extended Auxiliary Conveyor (Optional)</b> -  5.5 kW (Motorized Pulley)</h4></li> 

            </ul>
          </mat-tab>
        </mat-tab-group>
      </div>

    





      <hr>
    </ng-container>
    <ng-container class="app-modal-footer">
      <span (click)="fromtrack();modalRootmetal.hide();modalRoot.show()" class="product-catagory">Feed Hopper<img style="height: 37px;margin-bottom: -15px;" src="assets/arr.svg"> </span>
    </ng-container>
  </ngx-modal-window>


  <ngx-modal-window #modalRootdust class="modal-demo" style="display: block;visibility: visible;left: 29px;top: 162.5px;">
    <ng-container class="app-modal-header"><h4 style="color: white;font-size: 18px;">Dust Suppression System <br>(Optional Feature)</h4></ng-container>
    <ng-container class="app-modal-body">
      <img src="assets/img/dust.jpg" alt=""  style="width: 108.5%;margin-top: -19px;margin-left: -15px;height: 298px;"/>

      <div class="product-details">
        <mat-tab-group mat-align-tabs="start">
          <mat-tab label="Overview">
            <ul>
              <li><h4> &#9658;Diminish the dust at discharge.</h4></li>
              <li><h4> &#9658; High operator compatibility & safe working environment.</h4></li>
            </ul>  
          </mat-tab>
          <mat-tab label="Specification">
            <ul>        
              <li><h4> &#9658; <b>Spray Bar Water Pump</b> - 1.0 kW</h4></li>
              <li><h4> &#9658; <b>Water Tank</b> -  External Source</h4> </li>
    
          </ul>
          </mat-tab>
        </mat-tab-group>
        <!-- <span class="product-catagory">Women,bag</span> -->
      </div>
      <hr>
    </ng-container>
    <ng-container class="app-modal-footer">
      <span (click)="fromenv();modalRootdust.hide();modalRootmetal.show()" class="product-catagory">Conveyors<img style="height: 37px;margin-bottom: -15px;" src="assets/arr.svg"> </span>
    </ng-container>
  </ngx-modal-window>

  
</div>




<div id="lock"  class="text-center" > 
  
 
<div class="popScroll">
  <div class="popup">
    <span class="ribbon top-left ribbon-primary">
    <small>Notice!</small>
    </span> 
      <br>
      <br>
    <p>Kindly enable Auto Rotate option in your device and view in Landscape Mode.</p>
    <img src="assets/rotatedevice.gif" class="img-fluid" alt="">
 
  </div>
  </div>
  
</div>


<ngx-ui-loader></ngx-ui-loader>